import { render } from "./AllHealthFiles.vue?vue&type=template&id=aa4b5742"
import script from "./AllHealthFiles.vue?vue&type=script&lang=js"
export * from "./AllHealthFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__